import { useApiInfiniteQuery, type Api } from "../../../services/api";

const limit = 20;

export type SearchRoomItem =
  Api["get"]["/webapp/public/rooms/search"]["output"]["body"]["docs"][number];

export function useSearchRoomsQuery(
  searchValue: string,
  { enabled = true }: { enabled?: boolean } = {}
): {
  rooms: SearchRoomItem[];
  total: number;
  isLoading: boolean;
  isFetching: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
} {
  const trimmed = searchValue.trim();
  const isEnabled = enabled && trimmed.length > 0;

  const query = useApiInfiniteQuery(
    "/webapp/public/rooms/search",
    isEnabled ? { query: { search: trimmed, limit } } : false
  );

  const rooms = query.state === "success" ? query.docs : [];
  const total =
    query.state === "success" && query.total !== undefined ? query.total : 0;

  return {
    rooms,
    total,
    isLoading: query.state === "pending",
    isFetching: query.state === "success" ? query.isFetching : false,
    hasNextPage: query.state === "success" && query.canFetchNextPage,
    fetchNextPage:
      query.state === "success" ? query.fetchNextPage : () => undefined,
  };
}
